import { BoxTypes, RightMainBox } from '~/components/Layout';
import MultiAppHeader from './MultiAppHeader';
import { createSignal } from 'solid-js';
import AddNewApplicationModal from './AddNewApplicationModal';
import MultiApplicationList from './MultiApplicationList';

export default function MultiApplications() {
  const [addNewApplication, setAddNewApplication] = createSignal(false);

  const handleAddNewApplication = () => {
    setAddNewApplication(true);
  };

  return (
    <RightMainBox boxType={BoxTypes.FULL}>
      <MultiAppHeader btnOnClick={handleAddNewApplication} />
      <AddNewApplicationModal
        showAddNewAppModal={addNewApplication()}
        onClose={() => setAddNewApplication(false)}
      />
      <MultiApplicationList />
    </RightMainBox>
  );
}
